import { useEffect, useState } from "react";
import { useGetTodosByColorQuery, useGetTodosQuery  } from "../features/api/apiSlice";
import Loader from "./ui/loaders/Loader";

export default function Footer() {
    const [status, setStatus]= useState('All');
    const [colors, setColors] = useState('red');
    // const colors = ["red"];

    const {data: todos, isLoading, isError} = useGetTodosQuery();
    // console.log(todos);
    const {isLoading: colorLoading, isError: colorError}= useGetTodosByColorQuery(colors)    
    
    const handleStatusChange = (status) => {
        setStatus(status);
        // getTodos(status);
    }
    
    const handleColorChange = (color) => {
        setColors(color);
    }

    // useEffect( () => {
    //     // getTodosByColor(colors);
    // }, [colors])

    const numberOfTodos = (no_of_todos) => {
        switch (no_of_todos) {
            case 0:
                return "No task";
            case 1:
                return "1 task";
            default:
                return `${no_of_todos} tasks`;
        }
    };
    let content = null;
    let todosRemaining;
    if(isLoading){
        content = <Loader />
    }

    if( !isLoading && isError ) {
        content = "There was an error";
    }

    if( !isLoading && !isError && todos?.length > 0){
        content = '';
        todosRemaining = todos.filter((todo) => !todo.completed).length;
    }

    // const todosRemaining = todos.filter((todo) => !todo.completed).length;
    return (
        <div className="mt-4 flex justify-between text-xs text-gray-500">
            <p>{!isLoading && numberOfTodos(todosRemaining)} left</p>
            <ul className="flex space-x-1 items-center text-xs">
                <li
                    className={`cursor-pointer ${status === "All" && "font-bold"
                        }`}
                    onClick={() => handleStatusChange("All")}
                >
                    All
                </li>
                <li>|</li>
                <li
                    className={`cursor-pointer ${status === "Incomplete" && "font-bold"
                        }`}
                    onClick={() => handleStatusChange("Incomplete")}
                >
                    Incomplete
                </li>
                <li>|</li>
                <li
                    className={`cursor-pointer ${status === "Complete" && "font-bold"
                        }`}
                    onClick={() => handleStatusChange("Complete")}
                >
                    Complete
                </li>
                <li></li>
                <li></li>
                <li
                    className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${colors.includes("green") && "bg-green-500"
                        }`}
                    onClick={() => handleColorChange("green")}
                ></li>
                <li
                    className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${colors.includes("red") && "bg-red-500"
                        }`}
                    onClick={() => handleColorChange("red")}
                ></li>
                <li
                    className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${colors.includes("yellow") && "bg-yellow-500"
                        }`}
                    onClick={() => handleColorChange("yellow")}
                ></li>
            </ul>
        </div>
    );
}